  
import React from 'react'
import Fa from 'react-fontawesome'
import Switch from 'react-bootstrap-switch'

import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css"

export default class CropperControls extends React.Component {

    edit(param,value) {
        this.props.onEdit(param,value)
    }

    option(param,value) {
        this.props.onOptionChange(param,value)
    }

    render() {
      let b = 'btn btn-primary'
        return (
      <div className='controls'>
            <span>
            <button className={b} onClick={() => this.option('landscape', !this.props.landscape) }><Fa name='exchange' /> </button>
            <button className={b} onClick={() => this.edit('setDragMode', 'move') }><Fa name='arrows' /> </button>
            <button className={b} onClick={() => this.edit('setDragMode', 'crop') }><Fa name='crop' /> </button>    
            <button className={b} onClick={() => this.edit('rotate', -45) }><Fa name='rotate-left' /> </button>
            <button className={b} onClick={() => this.edit('rotate', 45) }><Fa name='rotate-right' /> </button>
            <button className={b} onClick={() => this.edit('zoom', 0.1) }><Fa name='search-plus' /> </button>     
            <button className={b} onClick={() => this.edit('zoom', -0.1) }><Fa name='search-minus' /> </button>
            <button className={b} onClick={() => this.edit('reset') }><Fa name='refresh' /> </button>
              </span>
          <Switch className="controls" labelText="black bg" size="mini"  onChange= {() => this.option('fillBlack', !this.props.fillBlack)} value={this.props.fillBlack} />
                <Switch className="controls" labelText="dithering" size="mini" onChange= {() => this.option('dithering', !this.props.dithering)} value={this.props.dithering} />
      </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/CropperControls.js